import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { FocusMeDirective } from '../../../shared/directives/focus-me.directive';

export const RESPONSE_CONFIRM = 0;
const RESPONSE_CANCEL = 1;

@Component({
	selector: 'copo-card-dialog-cancel-issue',
	templateUrl: './dialog-cancel-issue.component.html',
	styleUrl: './dialog-cancel-issue.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, MatIconModule, NgIf, MatButtonModule, FocusMeDirective, MatDialogModule]
})
export class DialogCancelIssueComponent {
	issueName: string | undefined;

	constructor(

		private readonly dialogRef: MatDialogRef<DialogCancelIssueComponent, number>
	) {}

	evtCancel() {
		this.dialogRef.close(RESPONSE_CANCEL);
	}

	evtConfirm() {
		this.dialogRef.close(RESPONSE_CONFIRM);
	}
}
